/**
 * An async function to wait the specified amount of time before
 *  continuing to execute.
 */
export const sleep = (delayMs: number) =>
  new Promise((resolve) => setTimeout(resolve, delayMs));
